import React from 'react'

const Whiten = ({ className }) => {
  return (
    <svg
      width={46}
      height={46}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={23} cy={23} r={23} fill="#B1B1B1" fillOpacity="0.22" />
      <path
        className="ac-s"
        opacity="0.58"
        d="M23 19.2692C22.0485 18.4767 20.8254 18 19.4911 18C16.4585 18 14 20.4624 14 23.5C14 26.5376 16.4585 29 19.4911 29C20.8254 29 22.0485 28.5233 23 27.7308"
        stroke="white"
      />
      <circle className="ac-s" cx="27.5" cy="23.5" r={6} stroke="white" />
      <path
        className="ac-s"
        d="M31 24C31 21.7909 29.2091 20 27 20"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Whiten
